import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import type { EmployeeAwardGrant } from '../../types';
import { subscribeToUserAwardGrants } from '../../utils/employeeAchievements';
import './UserAwardGrantsList.css';

interface UserAwardGrantsListProps {
  userId: string;
}

const UserAwardGrantsList: React.FC<UserAwardGrantsListProps> = ({ userId }) => {
  const [grants, setGrants] = useState<EmployeeAwardGrant[]>([]);

  useEffect(() => subscribeToUserAwardGrants(userId, setGrants), [userId]);

  if (grants.length === 0) {
    return <p className="um-award-grants-empty">No awards granted yet.</p>;
  }

  return (
    <div className="um-award-grants">
      <h4 className="um-award-grants-h">Awards &amp; certifications</h4>
      <ul className="um-award-grants-list">
        {grants.map(g => (
          <li key={g.id} className="um-award-grants-item">
            <img src={g.iconUrl} alt="" className="um-award-grants-icon" />
            <div className="um-award-grants-body">
              <span className="um-award-grants-name">{g.awardName}</span>
              <span className="um-award-grants-date">{format(g.grantedAt, 'MMM d, yyyy')}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserAwardGrantsList;
